import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import TinySlider from "tiny-slider-react";
import moment from "moment";
import { useTranslation } from "react-i18next";

import { useAppDispatch } from "../redux/hook";
import Accountabilities from "./accountabilities";
import portfolio1 from "../assets/images/portfolio/accountabilty_01.jpg";
import portfolio2 from "../assets/images/portfolio/accountabilty_02.jpg";
import portfolio3 from "../assets/images/portfolio/accountabilty_03.jpg";
import { fetchAccountabilityEdit } from "../redux/actions/accountabilityAction";

import "../../node_modules/tiny-slider/dist/tiny-slider.css";

const settings = {
  container: ".tiny-one-item",
  items: 1,
  controls: true,
  mouseDrag: true,
  loop: true,
  rewind: true,
  autoplay: true,
  autoplayButtonOutput: false,
  autoplayTimeout: 3000,
  navPosition: "bottom",
  controlsText: [
    '<i class="mdi mdi-chevron-left "></i>',
    '<i class="mdi mdi-chevron-right"></i>',
  ],
  nav: false,
  speed: 400,
  gutter: 0,
};

export default function AccountabilityFour({ id }) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [accountabilityData, setAccountabilityData] = useState({});
  const [loading, setLoading] = useState(true);

  const image = [portfolio1, portfolio2, portfolio3];

  useEffect(() => {
    if (id > 0) {
      const loadAccountabilty = async () => {
        const accountabilty = await dispatch(fetchAccountabilityEdit({ id }));
        if (
          typeof accountabilty.payload === "string" ||
          accountabilty.payload === undefined
        ) {
          setLoading(false);
          // navigate(checkError(homeEdit.payload));
        } else {
          setLoading(false);
          setAccountabilityData(accountabilty.payload);
        }
      };
      loadAccountabilty();
    } else {
      setLoading(false);
    }
  }, [dispatch, id]);

  if (loading) {
    return (
      <Box
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          top: "50%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return id > 0 ? (
    <>
      <div className="relative">
        <div className="shape absolute sm:-bottom-px -bottom-[2px] start-0 end-0 overflow-hidden z-1 text-white dark:text-slate-900">
          <svg
            className="w-full h-auto scale-[2.0] origin-top"
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>
      <section className="relative md:py-24 py-16">
        <div className="container relative">
          <div className="grid grid-cols-1 relative">
            <div className="tiny-one-item">
              <TinySlider settings={settings}>
                {image.map((item, index) => {
                  return (
                    <div className="tiny-slide" key={index}>
                      <div className="m-2">
                        <img
                          src={item}
                          className="rounded-xl shadow dark:shadow-gray-800"
                          alt=""
                        />
                      </div>
                    </div>
                  );
                })}
              </TinySlider>
            </div>
          </div>
        </div>

        <div className="container relative md:mt-24 mt-16">
          <div className="grid md:grid-cols-12 grid-cols-1 gap-6">
            <div className="lg:col-span-4 md:col-span-5">
              <div className="bg-gray-50 dark:bg-slate-800 shadow dark:shadow-gray-800 p-6 rounded-xl">
                <h5 className="text-lg font-semibold border-b border-gray-100 dark:border-gray-700 pb-3 mb-3">
                  {t("external.accountability.informations")}:
                </h5>
                <dl className="grid grid-cols-12 mb-0">
                  <dt className="md:col-span-4 col-span-5 mt-2">
                    {t("external.accountability.month")}:
                  </dt>
                  <dd className="md:col-span-8 col-span-7 mt-2 text-slate-400">
                    {accountabilityData.date &&
                      moment(accountabilityData?.date)?.format("DD/MM/YYYY")}
                  </dd>

                  <dt className="md:col-span-4 col-span-5 mt-2">
                    {t("external.accountability.name")}:
                  </dt>
                  <dd className="md:col-span-8 col-span-7 mt-2 text-slate-400">
                    {accountabilityData.name}
                  </dd>

                  <dt className="md:col-span-4 col-span-5 mt-2">
                    {t("external.accountability.entry")}:
                  </dt>
                  <dd className="md:col-span-8 col-span-7 mt-2 text-slate-400">
                    {accountabilityData.entry}
                  </dd>

                  <dt className="md:col-span-4 col-span-5 mt-2">
                    {t("external.accountability.exit")}:
                  </dt>
                  <dd className="md:col-span-8 col-span-7 mt-2 text-slate-400">
                    {accountabilityData.exit}
                  </dd>

                  <dt className="md:col-span-4 col-span-5 mt-2">
                    {t("external.accountability.balance")}:
                  </dt>
                  <dd className="md:col-span-8 col-span-7 mt-2 text-slate-400">
                    {accountabilityData.balance}
                  </dd>
                </dl>
              </div>
            </div>

            <div className="lg:col-span-8 md:col-span-7">
              <div className="lg:me-5">
                <h4 className="text-xl font-semibold mb-3 border-b border-gray-100 dark:border-gray-700 pb-3">
                  {t("external.accountability.accountability")}:
                </h4>
                {accountabilityData.description}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  ) : (
    <Accountabilities />
  );
}
